export default __webpack_public_path__ + "static/media/items_xiapu01.8a46f719.jpg";